import { createFileRoute, redirect, useLocation } from '@tanstack/react-router'
import { ContractTemplateEditorPage, contractTemplateSearchSchema } from '@/features/contract/index.ts'

export const Route = createFileRoute('/_authenticated/contracts/templates/$templateId')({
  beforeLoad: ({ params }) => {
    const templateId = Number(params.templateId)

    if (params.templateId !== 'new' && (!Number.isInteger(templateId) || templateId <= 0)) {
      throw redirect({ to: '/contracts/templates', replace: true, search: { current: 1, pageSize: 20 } })
    }
  },
  component: ContractTemplateEditorRoutePage,
  head: () => ({ meta: [{ title: '合同模板 · Super Mega' }] })
})

function ContractTemplateEditorRoutePage() {
  const { currentSession } = Route.useRouteContext()
  const { templateId } = Route.useParams()
  const savedSearch = useLocation({ select: (location) => location.state.contractTemplateReturnSearch })
  const search = contractTemplateSearchSchema.parse(savedSearch ?? {})
  const canManage =
    currentSession.isSuperAdmin ||
    currentSession.permissions.some(
      (permission) => permission.startsWith('contract.template.') && !permission.endsWith('.read')
    )
  return (
    <ContractTemplateEditorPage
      canManage={canManage}
      returnSearch={search}
      templateId={templateId === 'new' ? undefined : Number(templateId)}
    />
  )
}
